import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Card, TextInput, Textarea } from '@opendate-app/setlist';
import { useMembershipShowContext } from '../../startup/MembershipShowApp';

function AuthenticityField({ token }) {
  return <input type="hidden" name="authenticity_token" value={token} />;
}

AuthenticityField.propTypes = {
  token: PropTypes.string.isRequired,
};

export default function GiftPanel() {
  const {
    csrfToken, pendingGift, giftStatus, giftable, sendGiftPath, cancelGiftPath, canManageGift,
  } = useMembershipShowContext();
  const [open, setOpen] = useState(false);

  if (pendingGift) {
    const name = `${pendingGift.first_name} ${pendingGift.last_name}`;
    return (
      <div className="mb-3">
        <Alert
          color="brand"
          description={pendingGift.sends_on
            ? `Gift for ${name} (${pendingGift.email}) scheduled for ${pendingGift.sends_on}. They have until ${pendingGift.accept_deadline} to accept.`
            : `Gift waiting for ${name} (${pendingGift.email}) to accept by ${pendingGift.accept_deadline}.`}
          actions={canManageGift && (
            <form method="post" action={cancelGiftPath} onSubmit={(e) => { if (!window.confirm('Cancel this gift? The membership stays with the current member.')) e.preventDefault(); }}>
              <AuthenticityField token={csrfToken} />
              <Button type="submit" size="sm">Cancel gift</Button>
            </form>
          )}
        />
      </div>
    );
  }

  if (giftStatus) {
    return <div className="mb-3"><Alert color="gray" description={giftStatus} /></div>;
  }

  if (!canManageGift || !giftable) return null;

  return (
    <div className="mb-3">
      <Button size="sm" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls="membership-gift-form">
        Send as a gift
      </Button>
      <form id="membership-gift-form" hidden={!open} method="post" action={sendGiftPath} className="mt-2" style={{ maxWidth: 520 }}>
        <Card>
          <AuthenticityField token={csrfToken} />
          <p className="small mb-2">No money moves. The membership moves to the recipient when they accept and runs until the current term ends. Nothing changes for the current member until the recipient accepts; then it stops renewing on their card.</p>
          <div className="form-row">
            <div className="col-md-6 mb-2"><TextInput size="sm" name="gift[first_name]" placeholder="First name" aria-label="Recipient first name" required /></div>
            <div className="col-md-6 mb-2"><TextInput size="sm" name="gift[last_name]" placeholder="Last name" aria-label="Recipient last name" required /></div>
          </div>
          <div className="mb-2"><TextInput size="sm" type="email" name="gift[email]" placeholder="Recipient email" aria-label="Recipient email" required /></div>
          <div className="mb-2"><Textarea size="sm" name="gift[note]" placeholder="Note (optional)" aria-label="Note" maxLength={1000} rows={2} /></div>
          <Button type="submit" variant="primary" size="sm">Send gift</Button>
        </Card>
      </form>
    </div>
  );
}

GiftPanel.propTypes = {};
